import { render, staticRenderFns } from "./DServices.vue?vue&type=template&id=8096d2ae&scoped=true&"
import script from "./DServices.vue?vue&type=script&lang=js&"
export * from "./DServices.vue?vue&type=script&lang=js&"
import style0 from "./DServices.vue?vue&type=style&index=0&id=8096d2ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8096d2ae",
  null
  
)

export default component.exports